<template>
  <div class="main-container">
    <header class="ai-center jc-between">
      <div class="logo flex ai-center">
        <img src="../assets/logo.png" alt="logo">
        <h4>Share Link</h4>
      </div>
      <div class="nav">
        <ul class="flex">
          <li>
            <router-link to="Register">Sign Up</router-link>
          </li>
          <li>
            <router-link to="/login">Sign In</router-link>
          </li>
        </ul>
      </div>
    </header>

    <div class="content-container flex dir-column ai-center jc-center">
      <h1>One link to rule them all</h1>
      <p>Share your links, showcase your content</p>
      <p>All in one place.</p>
      <div class="start-button middle" @click="goSignUp">
        GET STARTED
      </div>
      <div class="phone">
        <div class="phone-frame">
          <div class="phone-screen dir-column ai-center">
            <div class="phone-header middle">
              <div class="speaker"></div>
              <div class="camera"></div>
            </div>

            <div class="profile-image"></div>
            <h3 class="profile-title">Yavuz Selim</h3>
            <div class="row">
              <LinkButton :name="'instagram'" :link="'https://instagram.com'" />
            </div>
            <div class="row">
              <LinkButton :name="'youtube'" :link="'https://youtube.com'" />
            </div>
            <div class="row">
              <LinkButton :name="'twitch'" :link="'https://twitch.tv'" />
            </div>
            <div class="row">
              <LinkButton :name="'website'" :link="'https://example.com'" />
            </div>

            <div class="phone-footer"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="about dir-column ai-center">
      <h1 class="about-title">Share what's important to you</h1>
      <div class="about-content flex">
        <div class="product link-product">
          <div class="product-header flex ai-center">
            <i class="fas fa-link"></i>
            <h3>Link to anywhere</h3>
          </div>
          <div class="product-body">
            <p>Your channel, your website, your account in one link.</p>
          </div>
        </div>
        <div class="product youtube-product">
          <div class="product-header flex ai-center">
            <i class="fab fa-youtube"></i>
            <h3>Youtube</h3>
          </div>
          <div class="product-body">
            <p>Showcase your YouTube videos right in your bio</p>
          </div>
        </div>
        <div class="product twitch-product">
          <div class="product-header flex ai-center">
            <i class="fab fa-twitch"></i>
            <h3>Twitch</h3>
          </div>
          <div class="product-body">
            <p>Your live stream account with the others.</p>
          </div>
        </div>
        <div class="product website-product">
          <div class="product-header flex ai-center">
            <i class="fas fa-window-maximize"></i>
            <h3>Website</h3>
          </div>
          <div class="product-body">
            <p>Your personal website in this link for people can learn more about you.</p>
          </div>
        </div>
      </div>
    </div>
    <footer class="flex jc-center">
      <div class="col flex dir-column">
        <h3>Get Started</h3>
        <router-link to="/login">Sign In</router-link>
        <router-link to="/register">Sign Up</router-link>
      </div>
      <div class="col flex dir-column">
        <h3>&copy;2021 CopyRight.</h3>
        <p>Made By <span @click="goMyWebsite">Heaven.</span></p>
      </div>
    </footer>
  </div>
</template>

<script>
import LinkButton from './../components/LinkButton';

export default {
  name: 'Home',
  components: {
    LinkButton
  },
  methods: {
    goMyWebsite() {
      window.open('https://yavuzselim.netlify.app','_blank');
    },
    goSignUp() {
      this.$router.push('/register');
    }
  }
}
</script>

<style scoped>

header {
  width: 100%;
  height: 75px;
  background-color: #569f81;
  padding-inline: 3rem;
}

header .logo img {
  width: 35px;
  margin-right: 10px;
}

header h4 {
  font-family: 'Mulish' , sans-serif;
  font-weight: bold;
  font-size: 23px;
}

header .nav ul li {
  margin-inline: 10px;
}

header .nav ul li a { 
  font-family: 'Poppins' , sans-serif;
  color: black;
}

.content-container {
  width: 100%;
  padding-block: 50px;
  background-color: #569f81;
}

.content-container h1 {
  font-size: 60px;
  font-family: 'yellowtail' , sans-serif;
  font-weight: 500;
  margin-bottom: 25px;
  color: white;
  letter-spacing: 1px;
  text-align: center;
}

.content-container p {
  font-family: 'Mulish' , sans-serif;
  color: white;
  letter-spacing: .2px;
  font-weight: lighter;
}

.start-button {
  width: 320px;
  height: 45px;
  border-radius: 10px;
  background-color: #2C9CFE;
  color: white;
  font-family: 'Mulish' , sans-serif;
  margin-block: 35px;
  font-size: 20px;
  cursor: pointer;
  user-select: none;
}

.phone {
  width: 320px;
  height: 600px;
  background-color: #111111;
  border-radius: 40px;
  padding: 5px;
}

.phone-frame {
  width: 100%;
  height: 100%;
  background-color: #1f1f1f;
  border-radius: 37px;
  padding: 5px;
  position: relative;
}

.phone-header {
  width: 150px;
  height: 25px;
  background-color: #1f1f1f;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  left: 50%;
  top: 0px;
  transform: translateX(-50%);
}

.speaker {
  width: 50px;
  height: 7px;
  background-color: #111111;
  border-radius: 99px;
  box-shadow: 0px -3px 2px 0px rgba(255,255,255,.1) inset;
  margin-right: 10px;
  margin-left: 13px;
}

.camera {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #111111;
  box-shadow: 0px -3px 2px 0px rgba(255,255,255,.1) inset;
  position: relative;
}

.camera::before {
  content: '';
  width: 2px;
  height: 2px;
  background-color: #293b50;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-70%, -70%);
}

.phone-footer {
  width: 150px;
  height: 3px;
  background-color: white;
  border-radius: 99px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.phone-screen {
  width: 100%;
  height: 100%;
  border-radius: 33px;
  background-image: url('https://data.whicdn.com/images/266331539/original.gif');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  padding-block: 50px;
}

.profile-image {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-image: url('https://cdn.discordapp.com/attachments/741666254942896239/812539854369980476/2641a68ef7964fc0b7e3aa1c164d9db6.jpg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 20px;
}

.profile-title {
  font-family: 'Poppins' , sans-serif;
  color: white;
  letter-spacing: 1px;
  font-weight: lighter;
  font-size: 20px;
}

.row {
  width: 90%;
  height: 30px;
  margin-block: 15px;
}

.about {
  width: 100%;
  padding-block: 50px;
  background-color: white;
}

.about-title {
  font-family: 'Mulish' , sans-serif;
  font-size: 25px;
  font-weight: lighter;
  margin-bottom: 25px;
}

.about-content {
  width: 800px;
  flex-wrap: wrap;
  max-width: 95%;
}

.product {
  width: 350px;
  height: 200px;
  border-radius: 25px;
  color: white;
  padding: 20px;
  margin: 15px;
}

.product-header {
  width: 100%;
  margin-bottom: 15px;
}

.product-header i {
  font-size: 25px;
  margin-right: 10px;
}

.product-header h3 {
  font-family: 'Mulish' , sans-serif;
  letter-spacing: 1px;
}

.product-body {
  width: 100%;
  font-family: 'Poppins' , sans-serif;
  font-size: 20px;
}

.youtube-product {
  background-color: #d80001;
}

.link-product {
  background-color: #2C9CFE;
}

.twitch-product {
  background-color: #9147ff;
}

.website-product {
  background-color: #000000;
}

footer {
  width: 100%;
  padding: 3rem;
  background-color: #29496f;
}

footer .col {
  margin-inline: 15px;
  color: white;
}

footer .col h3 {
  font-family: 'Mulish' , sans-serif;
  font-weight: lighter;
  margin-bottom: 10px;
}

footer .col a {
  color: white;
  font-family: 'Poppins' , sans-serif;
  font-size: 15px;
}

footer .col p {
  font-family: 'Poppins' , sans-serif;
  text-align: center;
}

footer .col span {
  padding: 2px;
  cursor: pointer;
}

footer .col span:hover {
  background-color: black;
  color: white;
}

@media screen and (max-width: 420px){
  header {
    flex-direction: column;
    padding-block: 20px;
  }

  header .nav {
    margin-top: 15px;
  }
}

</style>